import { mapState, mapActions } from 'vuex';
import showShareAlert from '@f/share';
import shareTip from '@f/shareTip';
import {
  getUrlParam,
  isHllApp,
  isWeixinBrowser,
  isWxMiniProgram,
  parseURL,
  parseQuery,
  stringifyQuery
} from '@/utils';

export default {
  computed: {
    ...mapState('app', {
      actData: function(state) {
        return state[this.moduleName].actData;
      }
    })
  },
  methods: {
    ...mapActions('app', {
      getShareCode: function(dispatch) {
        return dispatch(`${this.moduleName}/getShareCode`);
      },
      reportInvited: function(dispatch, data) {
        return dispatch(`${this.moduleName}/reportInvited`, data);
      }
    }),
    url(mode, shareCode) {
      let loc = location;
      const urlObj = parseURL(loc.href);
      const queryObj = parseQuery();
      queryObj.fromShare = 'true';
      if (mode === 'invite' && shareCode) {
        queryObj['invitation_uuid'] = shareCode;
      }
      urlObj.search = `?${stringifyQuery(queryObj)}`;
      return urlObj.toString();
    },
    async invitedReport() {
      const invitationCode = getUrlParam('invitation_uuid');
      if (!invitationCode) {
        return;
      }
      if (
        this.actData &&
        this.actData.shareCode &&
        this.actData.shareCode === invitationCode
      ) {
        return;
      }
      try {
        await this.reportInvited({ invitationCode });
      } catch (error) {
        console.error('邀请上报出错');
      }
    },
    /**
     * 调起分享 options.shareMode = normal|invite
     * @param {Object} options
     */
    async launchShare(options = {}) {
      if (!isHllApp() && !isWeixinBrowser() && !isWxMiniProgram()) {
        return Promise.reject({ msg: '请前往货拉拉App进行分享~' });
      }
      const shareMode = options.shareMode || 'normal';
      let url;
      if (shareMode === 'invite') {
        // 如果是邀请分享需要获取 shareCode
        try {
          const shareCode = await this.getShareCode();
          url = this.url(shareMode, shareCode);
        } catch (error) {
          throw error;
        }
      } else {
        url = this.url();
      }
      const config = {
        title: this.actData.shareTitle,
        desc: this.actData.shareContent,
        img: this.actData.shareUrl,
        miniIco: this.actData.shareUrl,
        link: url,
        ...options
      };
      return new Promise(resolve => {
        showShareAlert({
          config,
          isShowErr: false,
          callback: target => {
            if (isWeixinBrowser() || isWxMiniProgram()) {
              shareTip({
                imgUrl: require(`../assets/images/share_tip.png`),
                width: '568px',
                top: '23px',
                right: '53px',
                duration: 5000
              });
              setTimeout(() => {
                resolve(target);
              }, 5000);
              return;
            }
            resolve(target);
          }
        });
      });
    }
  }
};
